export default __webpack_public_path__ + "static/media/logo-percent.8f706ecd.svg";